import { Component } from 'react';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { INITD } from '../constants/app';

class GoogleAnalytics extends Component {

  state = { 
    isGoogleAnalyticsInitialized: false,
    id: this.props.userId,
    appName: '/airfinder'
  };
  componentDidMount() {
    let host = document.location.hostname;
    if (host === 'dev2.airfinder.com') {
      this.setState({appName: '/airfinder-development'})
    } else if (host === 'pro.airfinder.com') {
      this.setState({appName: '/airfinder-production'})
    }
    this.props.history.listen((location, action) => {
      if (this.state.isGoogleAnalyticsInitialized) {
        ReactGA.pageview(this.state.appName + location.pathname);
      }
    });
  }

  componentWillReceiveProps(p) {    
    if (p.userId && this.props.initd === INITD) {
      this.setState({id: p.userId})
      this.initAnalytics(p.userId);
    }
  }

  initAnalytics(userId) {
    //let id = 'UA-159839063-1';    
    let id = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
    if (id) { 
      ReactGA.initialize(id, {
        debug: false,
        titleCase: false,
        gaOptions: {
          userId: userId
        }
      });
      ReactGA.set({ dimension1: userId });
      ReactGA.pageview(this.state.appName +  window.location.pathname);
      this.setState({isGoogleAnalyticsInitialized: true})
    } else {
      console.log('null Google Analytics tracking ID');
    }     
  }
  render() {
    return (this.props.children);
  }
}
const mapStateToProps = state => {
  const { userId, initd } = state;
  return {
    initd: initd,
    userId: userId,
  }
}

export default withRouter(connect(mapStateToProps)(GoogleAnalytics));



// WEBPACK FOOTER //
// ./src/router/GoogleAnalytics.js